import { useCallback } from "react";
import Link from "next/link";
import { useRouter } from "next/router";

/**
 * A next/link that prefetches on intent (hover / focus / touch) instead of as
 * soon as it scrolls into view.
 *
 * Next prefetches a visible <Link> automatically, which downloads *and
 * evaluates* the destination's bundle. For a light page that is free. For a
 * heavy one it is not: the valuation detail page's "Digital Form" link pulled
 * the report page's ~1.7 MB of @react-pdf/renderer and Filestack onto the main
 * thread of every valuation anyone opened, whether or not they ever opened the
 * form — hundreds of milliseconds of blocked main thread, during which clicks
 * (including Back) do nothing.
 *
 * Hovering or tab-focusing still warms it, so anyone actually heading there
 * gets the same instant navigation as before.
 */
const IntentLink = ({ href, children, ...rest }) => {
  const router = useRouter();

  const warm = useCallback(() => {
    if (href) router.prefetch(href).catch(() => {});
  }, [router, href]);

  return (
    <Link
      href={href}
      prefetch={false}
      onMouseEnter={warm}
      onFocus={warm}
      onTouchStart={warm}
      {...rest}
    >
      {children}
    </Link>
  );
};

export default IntentLink;
